import { Text, Link } from '@vitvio/design-system';
import { useTranslation } from '@vitvio/locales';
import { mixpanel } from '@vitvio/logging';

export function SupportText() {
  const { t } = useTranslation();
  const email = t('common:supportEmail');

  function handleSupportTextClick() {
    mixpanel.track('support_contact_clicked');
  }
  return (
    <Text mt="auto" fontSize="16px" colorToken="fg.muted" path="common:contactUs">
      <Link
        onClick={handleSupportTextClick}
        href={`mailto:${email}`}
        fontWeight="semibold"
        path="common:supportEmail"
      />
    </Text>
  );
}
